"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _MediaInterface = _interopRequireDefault(require("../media/MediaInterface"));

var _GeneratedCollectionDetails = _interopRequireDefault(require("../../../../business-objects/GeneratedCollectionDetails"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

// ref: Thunder.Models.ResponseModels.CollectionDefinition
var CollectionDefinition =
/*#__PURE__*/
function (_Backbone$Model) {
  _inherits(CollectionDefinition, _Backbone$Model);

  _createClass(CollectionDefinition, [{
    key: "defaults",
    value: function defaults() {
      return {
        id: '0',
        name: '',
        description: '',
        availabilityOption: '',
        showOnlyAvailable: false,
        showOnlyPrerelease: false,
        sortByAvailability: false,
        curatedCollectionDetails: null,
        generatedCollectionDetails: null,
        lastModified: null,
        order: 0,
        // Computed property
        totalItems: 0
      };
    }
  }, {
    key: "idAttribute",
    get: function get() {
      return 'id';
    }
  }, {
    key: "collectionOptions",
    get: function get() {
      var options = {
        includeFacets: false,
        perPage: this.pageSize || 6,
        shuffle: this.shuffle || this.isLuckyDay
      };

      if (this.get('sortByAvailability') || this.get('availabilityOption') === 'available-first') {
        options.availableFirst = true;
      }

      if (this.get('showOnlyAvailable') || this.get('availabilityOption') === 'available-only') {
        options.showOnlyAvailable = true;
      }

      if (this.get('showOnlyPrerelease')) {
        options.showOnlyPrerelease = true;
      }

      if (this.useListOrder) {
        options.sortBy = 'listorder';
      }

      return options;
    }
  }, {
    key: "isLuckyDay",
    get: function get() {
      return this.get('availabilityOption') === 'available-luckyday';
    }
  }, {
    key: "isGenerated",
    get: function get() {
      return !_(this.get('generatedCollectionDetails')).isEmpty();
    }
  }, {
    key: "isCurated",
    get: function get() {
      return !_(this.get('curatedCollectionDetails')).isEmpty();
    }
  }, {
    key: "useListOrder",
    get: function get() {
      return this.isCurated && this.get('curatedCollectionDetails').isOrdered;
    }
    /**
     * @prop {TitleCollection} collection
     * @memberof CollectionDefinition
     */

  }]);

  function CollectionDefinition() {
    var _this;

    _classCallCheck(this, CollectionDefinition);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CollectionDefinition).apply(this, arguments));
    _this._mediaInterface = new _MediaInterface["default"]();
    _this.titleCollection = _this._mediaInterface.items;

    _this.listenTo(_this.titleCollection, 'all', function () {
      _this.set('totalItems', _this.titleCollection.length);
    });

    return _this;
  }

  _createClass(CollectionDefinition, [{
    key: "fetchCollectionTitles",
    value: function fetchCollectionTitles(_ref) {
      var patronSettings = _ref.patronSettings,
          room = _ref.room;
      // Parse the current room's maturityLevels if there is a room, and a maturityLevels filter has been set
      var roomHasMaturityLevelFilter = !_.isEmpty(room && room.filters && room.filters.maturityLevels);

      var patronMaturityLevelPreferences = this._parsePatronAudienceSettings(patronSettings);

      if (this.isGenerated) {
        var genColDetails = this.get('generatedCollectionDetails');

        if (this.attributes.sortBy) {
          genColDetails.sortBy = this.attributes.sortBy;
        }

        if (!!this.get('showOnlyLuckyDayAvailable')) {
          genColDetails.showOnlyLuckyDayAvailable = true;
        }

        var details = new _GeneratedCollectionDetails["default"](genColDetails);
        var params = details.serializeForSearch();

        if (!!patronSettings.showOnlyAvailable) {
          params.showOnlyAvailable = true;
        } // If we are in a room with maturity filters applied, the filters will be apart of the collection definition and we can simply query for the collection
        // User preferences should NOT override a room's maturity filter


        if (roomHasMaturityLevelFilter) {
          return this._mediaInterface.fetchCollectionByParameters(params, this.collectionOptions);
        } // Otherwise determine if the User's maturity filter settings cover the collection's maturityLevel settings
        else {
            var generatedCollectionOptions = Object.assign({}, this.collectionOptions);

            if (!_(patronMaturityLevelPreferences).isEmpty() && _(params.maturityLevel).isEmpty()) {
              Object.assign(generatedCollectionOptions, {
                maturityLevel: patronMaturityLevelPreferences
              });
            } // Fake an empty response if all the auto generated collection's filters are not covered by the user's maturity level settings


            return this._patronFiltersPermitCollection(params.maturityLevel, patronMaturityLevelPreferences) ? this._mediaInterface.fetchCollectionByParameters(params, generatedCollectionOptions) : this._mediaInterface.fetchEmptyResponse();
          }
      } // else if "isCurated"
      else {
          var curatedCollectionOptions = Object.assign({}, this.collectionOptions);

          if (!!patronSettings.showOnlyAvailable) {
            curatedCollectionOptions.showOnlyAvailable = true;
          } // If we are NOT in a room, apply a user's maturity settings if present to the collection request
          // The expectation is that if none of the content satisfies the user's filter its acceptable that no results are returned


          if (_(room).isEmpty()) {
            Object.assign(curatedCollectionOptions, {
              maturityLevel: patronMaturityLevelPreferences
            });
          }

          return this._mediaInterface.fetchCollectionById(this.id, curatedCollectionOptions);
        }
    } // Convert the patron audience settings model into an array of filter terms that MediaInterface understands, ex:
    // "audience-setting": {
    //     "all"            : false,
    //     "juvenile"       : false,
    //     "youngadult"     : true,
    //     "generalcontent" : true,
    //     "adultonly"      : true
    // }
    // to: ["youngadult", "generalcontent", "adultonly"]

    /** @returns {string[]} */

  }, {
    key: "_parsePatronAudienceSettings",
    value: function _parsePatronAudienceSettings(patronSettings) {
      var patronAudienceSetting = patronSettings && patronSettings['audience-setting'] || {};

      if (_(patronAudienceSetting).isEmpty() || patronAudienceSetting.all) {
        return [];
      }

      var audienceFilters = [];

      _(patronAudienceSetting).each(function (isApplied, key) {
        if (isApplied && key !== "all") {
          audienceFilters.push(key);
        }
      });

      return audienceFilters;
    }
  }, {
    key: "_patronFiltersPermitCollection",
    value: function _patronFiltersPermitCollection() {
      var collectionMaturityFilters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var userMaturityFilters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      if (userMaturityFilters.length === 0) {
        return true;
      }

      var collectionLower = collectionMaturityFilters.map(function (filter) {
        return filter.toLowerCase();
      });
      var userLower = userMaturityFilters.map(function (filter) {
        return filter.toLowerCase();
      });
      return _(collectionLower).difference(userLower).length === 0;
    }
  }]);

  return CollectionDefinition;
}(Backbone.Model);

exports["default"] = CollectionDefinition;